import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config'
import Http from './http.js'

import 'primevue/resources/themes/bootstrap4-dark-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import '@/css/custom.css'
import '@/css/balance.css'

import { Guid } from '@/tools/Common.js'
import { FormatCurrency, FormatDate, FormatTime, FormatPercent } from '@/services/FormatService.js'

import AutoComplete from 'primevue/autocomplete'
import Button from 'primevue/button'
import FileUpload from 'primevue/fileupload'
import Tag from 'primevue/tag'
import Textarea from 'primevue/textarea'
import Card from 'primevue/card'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import OverlayPanel from 'primevue/overlaypanel'
import ProgressBar from 'primevue/progressbar'
import RadioButton from 'primevue/radiobutton'
import Sidebar from 'primevue/sidebar'
import Swal from 'sweetalert2'
import TabPanel from 'primevue/tabpanel'
import TabView from 'primevue/tabview'
import ToastService from 'primevue/toastservice'
import Toast from 'primevue/toast'
import Tooltip from 'primevue/tooltip'
import TreeTable from 'primevue/treetable'

const app = createApp(App, {ripple: true})
app.use(PrimeVue)

app.config.globalProperties.$swal = Swal
app.config.globalProperties.$guid = Guid

app.config.globalProperties.$formatCurrency = FormatCurrency
app.config.globalProperties.$formatDate = FormatDate
app.config.globalProperties.$formatTime = FormatTime
app.config.globalProperties.$formatPercent = FormatPercent
app.config.globalProperties.$http = Http

app.use(ToastService)
app.use(store)
app.use(router)

app.component('AutoComplete', AutoComplete)
app.component('Button', Button)
app.component('FileUpload', FileUpload)
app.component('Tag', Tag)
app.component('Textarea', Textarea)
app.component('Card', Card)
app.component('Checkbox', Checkbox)
app.component('Column', Column)
app.component('ColumnGroup', ColumnGroup)
app.component('DataTable', DataTable)
app.component('Dialog', Dialog)
app.component('Dropdown', Dropdown)
app.component('InputText', InputText)
app.component('InputNumber', InputNumber)
app.component('OverlayPanel', OverlayPanel)
app.component('ProgressBar', ProgressBar)
app.component('RadioButton', RadioButton)
app.component('Sidebar', Sidebar)
app.component('TabPanel', TabPanel)
app.component('TabView', TabView)
app.component('Toast', Toast)
app.directive('Tooltip', Tooltip)
app.component('TreeTable', TreeTable)

app.mount('#app')
